import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPowerOff } from '@fortawesome/free-solid-svg-icons/faPowerOff'
import { ButtonWithTooltip } from '../ButtonWithTooltip'
import styles from './OnOffButton.module.scss'
import { useHover } from '../../../hooks/useHover'

interface OnOffButtonProps {
    onClick: () => void
    isButtonOn: boolean | undefined
    className?: string
}

export const OnOffButton = (props: OnOffButtonProps) => {
    const { onClick, isButtonOn, className } = props

    const [hovered, { onMouseEnter, onMouseLeave }] = useHover()

    const tooltipMsg = isButtonOn ? 'Deactivate' : 'Activate'
    const ruleStateBtnColor = isButtonOn ? '#6FD1B9' : '#E95050'
    const ruleStateBtnOnHover = isButtonOn ? '#E95050' : '#6FD1B9'

    return (
        <ButtonWithTooltip tooltip={tooltipMsg}>
            <button
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                onClick={onClick}
                className={`${styles.onOffBtn} ${className}`}
                style={{ opacity: 1 }}
            >
                <FontAwesomeIcon
                    color={hovered ? ruleStateBtnOnHover : ruleStateBtnColor}
                    icon={faPowerOff}
                />
            </button>
        </ButtonWithTooltip>
    )
}
